const plainText = (value) =>
	value ? (
		<span className="truncate block max-w-[200px]" title={value}>
			{value}
		</span>
	) : (
		<span className="text-bgBase-800">-</span>
	);

const textColumn = (key, label, getValue) => ({
	key,
	label,
	minWidth: 140,
	defaultHidden: true,
	render: (row) => plainText(getValue(row)),
});

const companyFields = (getCompany) => [
	textColumn('website', 'Website', (row) => getCompany(row)?.websiteUrl),
	textColumn('street', 'Straße', (row) => getCompany(row)?.addressStreet),
	textColumn('postalCode', 'PLZ', (row) => getCompany(row)?.addressPostal),
	textColumn('city', 'Stadt', (row) => getCompany(row)?.addressCity),
];

/**
 * Single master-data fields of a contact row, hidden until shown via the column picker.
 * @param {(key: string|null|undefined) => string} roleLabel - From useContactRoles
 * @returns {Array<object>}
 */
export const contactSystemColumns = (roleLabel) => [
	textColumn('salutation', 'Anrede', (row) => row.crmContacts.salutation),
	textColumn('firstName', 'Vorname', (row) => row.crmContacts.firstName),
	textColumn('lastName', 'Nachname', (row) => row.crmContacts.lastName),
	textColumn('companyRole', 'Position', (row) => roleLabel(row.crmContacts.companyRole) || null),
	...companyFields((row) => row.crmContacts.crmCompanies),
];

/** Single master-data fields of a company row, hidden until shown via the column picker. */
export const COMPANY_SYSTEM_COLUMNS = [
	textColumn('phone', 'Telefon', (row) => row.crmCompanies?.phoneNumber),
	...companyFields((row) => row.crmCompanies),
];
